import React, { Component } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SimpleReactValidator from 'simple-react-validator';
import { history } from '../../../shared/configure-store';
import { toast, ToastContainer } from 'react-toastify';
import { Link, withRouter } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import Width from '../../../images/width.png';
import Height from '../../../images/height.png';
import Length from '../../../images/length.png';
import Api from '../../../libraries/api';
import { bindActionCreators } from "redux";
import { RootActions } from "../../../shared/root-action";
import { connect } from "react-redux";
import language from "../../../libraries/label-lang";
import AuthHelper from "../../../libraries/auth-helper";
import templateId from "../../../libraries/lang-id";
import _ from 'lodash';
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import CircularProgress from "@material-ui/core/CircularProgress";
import TableBody from "@material-ui/core/TableBody";
import QRCode from "qrcode.react";
import Logo from "../../../images/logo-black.png";
import ReactToPrint from "react-to-print";
import cloneDeep from 'lodash/cloneDeep';
import Image from "../../../images/product.png";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import NumberFormat from "react-number-format";
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment'

SimpleReactValidator.addLocale('indo', templateId);

const triggerThis = () => {
    window.onbeforeunload = confirmExit;
    function confirmExit() {
        return "show message";
    }
};
const disableTriggerThis = () => {
    window.onbeforeunload = null;
};

class ReservationsAdd extends Component {

    constructor(props) {

        super(props);


        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );
        this.validatorAdd = new SimpleReactValidator(
            {
                locale: lang
            }
        );



        this.state = {
            loading: true,
            loading2: false,
            loading3: false,
            loadingProduct: true,
            loadingButton: false,
            loadingReservation: false,
            loadingChooseTime: false,
            step2: false,

            passed: false,

            showDialog: false,
            showDialogSummary: false,

            count: true,

            minutes: 15,
            seconds: 0,

            errors: [],
            error: '',

            timeout: '',

            countdown: '',

            time: '',
            products: [],

            productList: [],
            warehouseList: [],
            reservationList: [],
            storageList: [],

            selectedWarehouseAddress: '',

            image_name: '',
            skuNumber: '',
            name: '',
            storage: '',
            category: '',
            category_other: '',
            width: '',
            height: '',
            length: '',
            weight: '',
            supliedPackaging: '',
            otherpackaging: '',
            shelfLife: '',
            image: '',
            image_file: '',
            price: '',
            description: '',
            lockerSizeName: '',
            lockerSizeId: '',

            reservationId: 'cf5320e9-d71b-4199-8a82-4982738d24ef',//'0718983d-42b1-444e-ad84-94bd0247cfb4',//
            warehouse: '',

            newlyCreatedProductId: '',
            currentIndexProductList: '',

            // properties add
            productList_tmp: [],
            product: '',
            errStep1Time: '',

            createRes: false,
            createNote: false,
            // handle success
            loadingSuccess: false,
            email: '',
            labels: [],
            // handle note
            loadingNote: false,
            reservation_date: '',
            company_name: '',
            primary_address: '',
            primary_city: '',
            primary_state: '',
            contact_name: '',
            contact_phone_office: '',
            contact_phone_cell: '',
            contact_email: '',
            warehouseNote: '',
            warehouse_address: '',
            productsNote: [],

            data: [],

            dummy: [{ id: 1 }, { id: 2 }, { id: 2 }],
            isShuttle: 0,
            shuttleInfo: null

        }
    }

    componentDidMount() {

        document.title = 'Fresh Factory - Add Pengiriman';

        Api.get('/warehouses').then(resp => {
            if (resp.data) {

                this.setState({
                    warehouseList: resp.data,
                    loading: false,
                    createRes: false,
                    createNote: false
                })

            }
        }).catch(err => {
            this.showMessage(false, err.message);
        });

        Api.get('/storage').then(resp => {
            if (resp.data) {

                this.setState({
                    storageList: resp.data,
                    loading: false,
                })

            }
        }).catch(err => {
            this.showMessage(false, err.message);
        });
        this.__fetchProducts();
    };

    componentWillUnmount() {
        clearInterval(this.myInterval);
        disableTriggerThis();
    }

    // start function replace
    showMessage = (status, message) => {
        if (status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        } else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleAdd = (e) => {
        this.setState({
            errors: {},
        }
        );

        /*let exp = this.state.productList;
        let temp = {
            productId : '',
            name : '',
            sku : '',
            quantity : '',
            slot : false,
        };

        exp.push(temp);
        this.setState({
                productList: exp,
            }, () => {
                clearTimeout(this.state.timeout);
            }
        );*/

        let data = e.target.value;

        let exp = this.state.productList;
        let temp = {
            id: data.id,
            sku: data.skuNumber,
            quantity: 1,
            ikus: data.ikus,
            name: data.name,
            object: data.object,
            skuNumber: data.skuNumber,
            storage: data.storage,
            productId: data.id,
            lockerSizeId: '',
            lockerSizeName: '',
            price: 0,
            slot: false
        };

        exp.push(temp);
        this.setState({
            productList: exp,
        }, () => {
            this.handleChangeAdd({ target: { value: data.id } }, 'productId', exp.length - 1);
            this.handleReplaceList();
        });

    };

    __fetchProducts = (state) => {
        state = typeof state === 'undefined' ? false : state;
        Api.get('/products?limit=0').then(resp => {

            if (resp.data) {
                this.setState({
                    products: resp.data,
                    loadingProduct: false
                }, () => {
                    if (state) {
                        this.__inputNewlyCreatedProduct();
                    }
                });
            }
            this.handleReplaceList();

        }).catch(err => {
            this.setState({
                loadingProduct: false
            });
            this.handleReplaceList();
        });
    };

    handleStep1(e, prop) {

        if (prop === 'warehouse') {

            if (e.target.value) {

                let temp = '';

                _.forEach(this.state.warehouseList, function (item, index) {
                    if (e.target.value === item.id) {
                        temp = item.address1 + ' ' + item.address2 + ', ' + item.city + ', ' + item.state + ', ' + item.postalCode;
                    }
                });

                this.setState({

                    [prop]: e.target.value,
                    selectedWarehouseAddress: temp,

                    productList: [],
                    reservationId: '',
                    time: '',

                    loading2: true,
                    step2: false,

                }, () => {
                    this.__fetchReservationList(e.target.value);
                });

            }

        }
        else if (prop === 'time') {

            if (e.target.value) {

                this.setState({
                    [prop]: e.target.value,
                    loadingChooseTime: true,
                    errStep1Time: ''
                });
                let params = {
                    warehouseId: this.state.warehouse,
                    reservationDate: e.target.value,
                };

                Api.post('/reservation/times', params).then(resp => {

                    if (resp.status === 'success') {

                        triggerThis();

                        this.setState({
                            reservationId: resp.data.id,
                            step2: true,
                            loadingChooseTime: false,
                        });

                        this.__startTimer();
                    }

                }).catch(err => {

                    this.showMessage(false, err.message);

                    this.setState({
                        loadingChooseTime: false,
                        errStep1Time: err.message
                    });

                });
            }
        }
        else {

            this.setState({
                [prop]: e.target.value
            });

        }
    };

    __fetchReservationList = (id) => {
        this.setState({ loading2: true })
        const { isShuttle } = this.state

        let shuttle = isShuttle ? 1 : 0;
        let data = { warehouseId: id, isShuttle: shuttle.toString() };
        Api.post('/reservation/available', data).then(resp => {
            if (resp.data) {
                if (!!isShuttle) {
                    this.setState({
                        reservationId: resp.data.id,
                        shuttleInfo: resp.data,
                        loading2: false,
                        step2: true
                    });

                } else {
                    this.setState({
                        reservationList: resp.data,
                        loading2: false,
                        step2: false

                    });
                }
            }
        }).catch(err => {
            console.log(err);
            this.setState({
                loading2: false,
            });
            this.showMessage(false, err.message);
        });
    };

    __startTimer = () => {
        clearInterval(this.myInterval);
        this.setState({
            minutes: 15,
            seconds: 0,
        }, () => {
            this.__timerFn();
        });
    };

    __timerFn = () => {
        this.myInterval = setInterval(() => {
            const { seconds, minutes } = this.state;

            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.myInterval);
                    this.__resetData();
                    return false;
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    };

    __resetData = () => {
        this.setState({
            warehouse: '',
            time: '',
            products: [],
            productList: [],
            selectedWarehouseAddress: '',
            step2: false,
        });
    };

    handleChangeAdd = (e, prop, idx) => {

        let data = this.state.productList;
        let name = '';
        let sku = '';

        if (e.target.value <= 0) {
            this.showMessage(false, 'Minimal pemesanan 1');
            e.target.value = 1;
        }

        /*if(e.target.value === '0000'){
            this.handleOpen();
        }*/

        if (prop === 'productId') {
            name = this.filterName(e.target.value);
            sku = this.filterSKU(e.target.value);
        }
        _.forEach(data, function (v, k) {

            if (k === idx) {
                v[prop] = e.target.value;

                if (prop === 'productId') {
                    v.quantity = 1;
                    v.name = name;
                    v.sku = sku;

                    if (e.target.value === '0000') {
                        v.productId = '';
                    }
                }
            }
        });

        this.setState({
            errors: {},
            productList: data,
            currentIndexProductList: idx
        }, () => {
            this.__startTimer();
            let count = this.state.count;

            if(prop === 'quantity') {
            //this.checkSlot();

            if(count) {
                setTimeout(()=> {
                    this.checkSlot();
                    this.setState({
                        count: true,
                    });
                }, 3000);
            }

                this.setState({
                    count: false,
                });
            }
        });


    };

    handleOpen = () => {
        this.setState({
            showDialog: true,
        })
    };
    handleOpenSummary = () => {
        this.setState({
            showDialogSummary: true,
        })
    };

    filterName = (id) => {
        let all = this.state.products.filter((item) => item.id === id);
        if (all.length > 0)
            return all[0].name;
    };

    filterSKU = (id) => {
        let all = this.state.products.filter((item) => item.id === id);
        if (all.length > 0)
            return all[0].skuNumber;
    };

    checkSlot = () => {

        this.setState({
            loadingReservation: true,
            passed: false,
        });

        let temp = this.state.productList;
        let temp2 = _.filter(temp, function (o) { return o.quantity; });

        let params = {
            warehouseId: this.state.warehouse,
            reservationId: this.state.reservationId,
            products: temp2,
        };

        Api.post('/reservations', params).then(resp => {

            if (resp.status === 'success') {
                let products = resp.data;
                let temp = cloneDeep(this.state.productList);
                let tmp_lockersize = [];
                if (products.length > 0) {
                    let check = true;
                    _.forEach(products, function (v, k) {
                        _.forEach(temp, function (item, key) {
                            if (item.productId === v.product_id) {
                                if (v.price) {
                                    item.price = v.price;
                                    item.display_price = parseInt(v.price);
                                }
                                if (v.locker_size_id) {
                                    item.lockerSizeId = v.locker_size_id;
                                }
                                if (v.name) {
                                    item.lockerSizeName = v.name;
                                }

                                // if(v.width && v.height && v.length && v.storage){
                                //     item.lockerSizeName = '';
                                //     tmp_lockersize.push({w:v.width, h:v.height, l:v.length, s:v.storage});
                                //     // this.__fetchLockerSize(v.width,v.height,v.length,v.storage);
                                // }
                                if (v.available === 1) {
                                    item.slot = true;
                                } else {
                                    item.slot = false;
                                    // check = false;
                                }
                                if (v.available === 1 && item.lockerSizeName) {
                                    check = true;
                                } else {
                                    check = false;
                                }
                            }
                        });

                    });

                    let check2 = 0;
                    temp.map(c => {
                        if (c.slot && c.lockerSizeName) {
                            check2++;
                        }
                    });

                    // this.setState({
                    //     productList: n,
                    //     loading3: false,
                    //     passed: check > 0 && check == n.length ? true : false
                    // });
                    this.setState({
                        productList: temp,
                        loadingReservation: false,
                        passed: check2 > 0 && check2 == temp.length ? true : false,//check,
                        loading3: false //true
                    }, () => {
                        // this.__fetchLockerSize(tmp_lockersize);
                    });
                }
                this.__startTimer();

            }

        }).catch(err => {

            this.setState({
                loadingReservation: false,
            });

            // this.showMessage(false, err.message);

        });
    };

    __fetchLockerSize = (x_tmp) => {//(w,h,l,s) => {

        this.setState({
            loading3: true,
            passed: false
        });
        let n = this.state.productList;

        if (x_tmp && x_tmp.length) {
            x_tmp.map((g, idx) => {
                if (g) {
                    Api.post('/lockersize/find', {
                        width: g.w,
                        height: g.h,
                        length: g.l,
                        storage: g.s,
                    }).then(resp => {
                        if (resp.data.length === 0) {
                            n[idx].lockerSizeName = 0;
                            // this.setState({
                            //     lockerSizeName: 0,
                            //     loading3: false
                            // });
                            // return false
                        }
                        if (resp.data) {
                            if (n[idx].lockerSizeId == resp.data.id) {
                                n[idx].lockerSizeName = resp.data.name;
                            }
                            //
                            // this.setState({
                            //     productList: n,
                            //     loading3: false,
                            //     passed: check
                            // });
                        }
                        let check = 0;
                        n.map(c => {
                            if (c.slot && c.lockerSizeName) {
                                check++;
                            }
                        });

                        this.setState({
                            productList: n,
                            loading3: false,
                            passed: check > 0 && check == n.length ? true : false
                        });

                    }).catch(err => {
                        console.log(err);
                    });
                }
            })
        }
    };

    handleReservation = (e) => {

        e.preventDefault();

        this.setState({
            passed: false,
        });

        let params = {
            reservationId: this.state.reservationId,
        };

        Api.post('/reservation/submit', params).then(resp => {

            if (resp.status === 'success') {

                disableTriggerThis();

                this.setState({
                    passed: true,
                    createRes: true,
                    createNote: true,
                }, () => {
                    this.handleSuccess();
                    //this.handleNote();
                });

                // history.push('/reservation-success/'+this.state.reservationId);
            }


        }).catch(err => {
            let error = '';
            if(Array.isArray(err.message)) {
                error = err.message[0]
            }else {
                error = err.message
            }
            this.setState({
                passed: true,
                createRes: false,
                createNote: false
            });

            this.showMessage(false, error);

        });
    };
    // end replace

    // handle success
    handleSuccess = () => {
        this.setState({
            createNote: false,
            loadingNote: false,
        });

        let params = {
            reservationId: this.state.reservationId,
        };

        Api.post('/reservation/label', params).then(resp => {
            let dataLababels = [];
            let item = [];
            if (resp.data.length > 0) {
                _.forEach(resp.data, function (v, i) {
                    let row = i + 1;

                    let mod = row % 3;
                    if (mod === 1) {
                        item = [];
                    }
                    item.push(v);
                    if (mod === 1) {
                        dataLababels.push(item);
                    }/*else if(mod === 1) {
                        dataLababels.push(item);
                    }*/
                });

                this.setState({
                    labels: dataLababels,
                    // loadingSuccess: false,
                });
            }
        }).catch(err => {
            // this.setState({
            //     loadingSuccess: false,
            // });
            this.showMessage(false, err.message);
        });
    };

    // handle note
    handleNote = () => {
        this.setState({
            createNote: true,
            loadingNote: true,
            productsNote: []
        });
        Api.get('/reservation/nota?reservationId=' + this.state.reservationId).then(resp => {

            if (resp.data) {

                let data = resp.data;

                Api.get('/reservations/' + this.state.reservationId).then(resp1 => {
                    let data2 = resp1.data;
                    let generateData = [];
                    let nX = {};
                    let countNx = 0;
                    data.generateData = [];

                    if (data2 && data2.SKU && data2.SKU.length) {
                        data.products.map((i, ind) => {
                            if (i.sku_number) {
                                let locker = '';
                                data2.SKU.map(i2 => {
                                    if (i2.skuNumber == i.sku_number) {
                                        let all = i2.iku.filter((item) => {
                                            if (item && item.warehouse) {
                                                let nW = item.warehouse.split('/');
                                                item.sku = i.sku_number;
                                                item.warehouse = nW[0];
                                                item.slot = nW[1] + '/' + nW[2] + '/' + nW[3];
                                                return item;
                                            }
                                            else {
                                                return;
                                            }
                                        });

                                        all.map(item => {
                                            if (item) {
                                                if (nX[countNx] && Object.keys(nX[countNx]).length != 3) {
                                                    nX[countNx].push(item);
                                                }
                                                else if (nX[countNx] && Object.keys(nX[countNx]).length == 3) {
                                                    countNx++;
                                                    nX[countNx] = [
                                                        item, { name: 'split' }
                                                    ];
                                                }
                                                else {
                                                    nX[countNx] = [
                                                        item, { name: 'split' }
                                                    ];
                                                }
                                            }
                                        });

                                        i.IKU = all;
                                        locker = i2.iku[0] && i2.iku[0].lockerSize ? i2.iku[0].lockerSize : '-';
                                    }
                                });

                                i.lockerSize = locker;
                            }
                            if (data.products.length - 1 == ind) {
                            }
                        });

                        if (nX && Object.keys(nX).length) {
                            Object.keys(nX).map(key => {
                                if (nX[key] && nX[key].length) {
                                    generateData.push(nX[key]);
                                    data.generateData.push(nX[key]);
                                }
                            });
                        }
                    }
                    else {
                        data.products.map(i => {
                            if (i.sku_number) {
                                i.lockerSize = '-';
                            }
                        })
                    }

                    this.setState({
                        loadingNote: false,
                        reservation_id: this.props.match.params.id,
                        data: data,
                        reservation_date: data.reservation_date,
                        company_name: data.company_name,
                        primary_address: data.primary_address,
                        primary_city: data.primary_city,
                        primary_state: data.primary_state,
                        contact_name: data.contact_name,
                        contact_phone_office: data.contact_phone_office,
                        contact_phone_cell: data.contact_phone_cell,
                        contact_email: data.contact_email,
                        warehouseNote: data.warehouse,
                        warehouse_address: data.warehouse_address,
                        products: data.products,
                        productsNote: data.generateData //data.products,
                    }, () => {
                    });

                }).catch(err => {

                    // this.setState({
                    //     loadingReservation: false,
                    // });

                    // this.showMessage(false, err.message);

                });

                // this.setState({
                //     loadingNote: false,
                //     reservation_id: this.props.match.params.id,
                //     data: data,
                //     reservation_date: data.reservation_date,
                //     company_name: data.company_name,
                //     primary_address: data.primary_address,
                //     primary_city: data.primary_city,
                //     primary_state: data.primary_state,
                //     contact_name: data.contact_name,
                //     contact_phone_office: data.contact_phone_office,
                //     contact_phone_cell: data.contact_phone_cell,
                //     contact_email: data.contact_email,
                //     warehouseNote: data.warehouse,
                //     warehouse_address: data.warehouse_address,
                //     productsNote: data.products,
                // },()=>{
                //
                // });
            }
            else {
                this.setState({
                    loadingNote: false,
                    reservation_id: null,
                });
            }
        }).catch(err => {
            this.setState({
                loadingNote: false,
            });
            this.showMessage(false, err.message);
        });

    };

    handleMinus = (id) => {
        this.setState({
            errors: {},
        }
        );

        let data = this.state.productList.filter((e, idx) => e.id !== id);

        this.setState({
            productList: data,
        }, () => {
            this.checkSlot();
            this.handleReplaceList();
        });
    };

    handleReplaceList = () => {
        let x = Object.keys(this.state.productList);
        let n = [];
        this.state.products.map(f => {
            n.push(f);
        });
        if (x && x.length) {
            x.map(key => {
                if (key) {
                    let idCheck = this.state.productList[key].id;
                    if (n && n.length) {
                        let nC = 0;
                        n.map((d, xd) => {
                            if (d.id == idCheck) {
                                nC = xd + 1;
                            }
                        });
                        if (nC) {
                            n.splice(nC - 1, 1);
                        }
                    }
                }
            });

            this.setState({
                productList_tmp: n
            });
        }
        else {
            this.setState({
                productList_tmp: n
            });
        }
    };

    handleGo = (link) => {
        history.push(link);
    };

    __fetchLockerSize = (w, h, l, s) => {

        this.setState({

            loading3: true

        });

        let data = {
            width: w,
            height: h,
            length: l,
            storage: s,
        };
        Api.post('/lockersize/find', data).then(resp => {

            if (resp.data.length === 0) {
                this.setState({
                    lockerSizeName: 0,
                    loading3: false
                });

                return false
            }
            if (resp.data) {
                this.setState({
                    lockerSizeName: resp.data.name,
                    lockerSizeId: resp.data.id,
                    loading3: false
                });
            }

        }).catch(err => {
            console.log(err);
        });
    };

    handleAddProduct = (e) => {
        e.preventDefault();

        if (!this.validatorAdd.allValid()) {

            this.setState({
                errors: this.validatorAdd.getErrorMessages()
            }
            );

            return false;

        }

        this.setState({
            errors: {},
            loadingButton: true
        }
        );

        let formData = new FormData();
        formData.append('skuNumber', this.state.skuNumber);
        formData.append('name', this.state.name);
        formData.append('storage', this.state.storage);
        formData.append('category', this.state.category === 'Other' ? this.state.category_other : this.state.category);
        formData.append('width', this.state.width);
        formData.append('height', this.state.height);
        formData.append('length', this.state.length);
        formData.append('weight', this.state.weight);
        formData.append('supliedPackaging', this.state.supliedPackaging === 'Other' ? this.state.otherpackaging : this.state.supliedPackaging);
        formData.append('shelfLife', this.state.shelfLife);
        formData.append('description', this.state.description);
        formData.append('lockerSizeId', this.state.lockerSizeId);
        formData.append('price', this.state.price);
        formData.append('reservationId', this.state.reservationId);
        if (this.state.image_file) {
            formData.append('image', this.state.image_file);
        }

        Api.putFile('/products', {
            method: 'POST',
            body: formData
        }).then(resp => {

            this.setState({
                newlyCreatedProductId: resp.data.id,

                skuNumber: '',
                name: '',
                storage: '',
                category: '',
                category_other: '',
                width: '',
                height: '',
                length: '',
                weight: '',
                supliedPackaging: '',
                otherpackaging: '',
                shelfLife: '',
                description: '',
                lockerSizeId: '',
                lockerSizeName: '',
                price: '',
                image_file: '',
                image: '',
                image_name: '',
                reservationId: this.state.reservationId,
                showDialog: false,

            }, () => {
                this.__fetchProducts(true);
            });

            this.showMessage(true, 'Product successfully added');

        }).catch(err => {
            if (err.errors) {
                this.setState({
                    errors: err.errors,
                    loadingButton: false,
                    showDialog: false,
                }
                );
                this.showMessage(false, 'Invalid format data');
            } else {
                this.setState({
                    loadingButton: false
                }
                );
                this.showMessage(false, err.message);
            }
        });

        this.__startTimer();

    };

    handleUpload = e => {

        let temp = _.get(e, 'target.files[0]', false);

        this.setState({
            errors: { image: '' },
        });

        if (temp) {
            if (e.target.files[0].size > 999999) {

                this.setState({
                    errors: {
                        image: 'This file is too big. Maximum size is 1MB.'
                    },
                });

            } else if (e.target.files[0].name.toLowerCase().search('.jpeg') === -1 &&
                e.target.files[0].name.toLowerCase().search('.jpg') === -1 &&
                e.target.files[0].name.toLowerCase().search('.png') === -1) {

                this.setState({
                    errors: {
                        image: 'This file is invalid. Only accept .jpg, .jpeg and .png'
                    },
                });

            } else {

                this.setState({
                    image: URL.createObjectURL(e.target.files[0]),
                    image_file: e.target.files[0],
                    image_name: e.target.files[0].name,
                });

            }
        }
    };

    handleChange(e, prop) {

        this.setState({

            [prop]: e.target.value

        }, () => {

            this.__startTimer();
            if (prop === 'width' || prop === 'height' || prop === 'length' || prop === 'storage') {
                if (this.state.width && this.state.height && this.state.length && this.state.storage) {
                    this.__fetchLockerSize(this.state.width, this.state.height, this.state.length, this.state.storage)
                }
            }

        });

    };

    handleClose = () => {
        this.setState({
            showDialog: false,
            showDialogSummary: false,
        })
    };

    __inputNewlyCreatedProduct = () => {
        let currentIndex = this.state.currentIndexProductList;
        let id = this.state.newlyCreatedProductId;
        let productList = this.state.productList;
        _.forEach(productList, function (v, k) {
            if (k === currentIndex) {
                v['id'] = id;
            }
        });

        this.setState({
            productList: productList,
            showDialog: false,
            loadingButton: false,
        });

    };

    render() {
        let lang = {};
        if (this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        } else {
            lang = language.en;
        }
        const text = lang;

        const isStatusSuccess = (this.state.createRes && this.state.createRes == true ? true : false);
        const isStatusNote = (this.state.createNote && this.state.createNote == true ? true : false);


        if (isStatusSuccess && isStatusNote) {
            return (
                <div className='dashboard-detail'>
                    <nav aria-label='breadcrumb'>
                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'><Link to='/'>{text.label_dashboard}</Link></li>
                            <li className='breadcrumb-item'><Link to='/reservations'>{text.label_reservation}</Link>
                            </li>
                            <li className='breadcrumb-item active'
                                aria-current='page'>{text.button_add}</li>
                        </ol>
                    </nav>
                    <h2 className='text-uppercase'>{text.button_add} {text.label_reservation}</h2>

                    <div className='row'>
                        <div className='col-lg-12 col-xl-12 card-white mb-3'>
                            <div className='container text-center'>
                                <div className='row justify-content-center'>
                                    <div className='col-md-10 col-lg-8 text-center'>
                                        {/*<h1 className='text-big mb-5'>{text.note_heading}</h1>*/}
                                        {/*<div className='steps'>*/}
                                        {/*    <p className=' mb-0'><b>{text.note_heading}</b></p>*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                                {
                                    this.state.reservation_id === null ?
                                        <div className='row justify-content-center'>
                                            <div className='col-md-12 col-lg-12'></div>
                                        </div>
                                        :
                                        <div className='row'>
                                            {this.state.loadingNote ? (
                                                <div className='col-12'>
                                                    <i className='fa fa-spinner fa-spin'>&nbsp; </i>
                                                </div>
                                            ) : (
                                                    <div className='col-md-12 col-lg-12'>
                                                        <PrintLabelsNote lang={this.props.toggle_set_lang} data={this.state.data} ref={el => (this.componentRef = el)} />
                                                    </div>
                                                )}
                                            {this.state.loadingNote ? '' : (
                                                <div className='col-md-12 col-lg-12'>

                                                    <div className='row mt-4'>
                                                        <div className='col-md-6'>

                                                            <ReactToPrint
                                                                trigger={() => <Button
                                                                    variant='contained'
                                                                    className='btn-link'
                                                                ><i className="fas fa-print mr-2" > </i>
                                                                    {/*{text.button_print}*/}
                                                                    {text.button_print_delivery_note}
                                                                </Button>}
                                                                content={() => this.componentRef}
                                                            />
                                                        </div>
                                                        <div className='col-md-6 text-md-right'>
                                                            {/*<Button
                                                            variant='contained'
                                                            color='primary'
                                                            className='btn-link mr-3'
                                                            onClick={() => this.handleSuccess()}
                                                        >
                                                            {text.button_back}
                                                        </Button>*/}
                                                            <Button
                                                                variant='contained'
                                                                color='primary'
                                                                onClick={() => this.handleGo('/reservations')}
                                                            >
                                                                {text.button_done}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                    <ToastContainer autoClose={false} />
                </div>
            )
        }
        else if (isStatusSuccess) {
            return (
                <div className='dashboard-detail'>
                    <nav aria-label='breadcrumb'>
                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'><Link to='/'>{text.label_dashboard}</Link></li>
                            <li className='breadcrumb-item'><Link to='/reservations'>{text.label_reservation}</Link>
                            </li>
                            <li className='breadcrumb-item active'
                                aria-current='page'>{text.button_add}</li>
                        </ol>
                    </nav>
                    <h2 className='text-uppercase'>{text.button_add} {text.label_reservation}</h2>

                    <div className='row'>
                        <div className='col-lg-12 col-xl-12 card-white mb-3'>
                            <div className='container text-center'>
                                <div className='row justify-content-center'>
                                    <div className='col-md-10 col-lg-8 text-center'>
                                        <div className='steps'>
                                            <p className=' mb-0'><b>{text.reservation_step3_text}</b></p>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    {this.state.loadingSuccess ? (
                                        <div className='col-12'>
                                            <i className='fa fa-spinner fa-spin'>&nbsp; </i>
                                        </div>
                                    ) : (
                                            this.state.labels.length === 0 ? (
                                                <div className='col-12'>
                                                    <p>{text.label_no}</p>
                                                </div>
                                            ) : (
                                                    <PrintLabels data={this.state.labels} ref={el => (this.componentRef = el)} />
                                                )
                                        )}
                                </div>

                                <div className='mt-4 button-small'>
                                    <ReactToPrint
                                        trigger={() => <Button
                                            variant='contained'
                                            color='primary'
                                            className='mr-3'
                                            disabled={this.state.labels.length === 0}
                                        >Print</Button>}
                                        content={() => this.componentRef}
                                    />
                                    <Button
                                        variant='contained'
                                        className='btn-link mr-3'
                                        // disabled={this.state.labels.length === 0}
                                        onClick={() => this.handleNote()}
                                    >
                                        {text.button_next}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer autoClose={false} />
                </div>
            )
        }
        else {
            return (

                <div className='dashboard-detail'>
                    {/* pin1 */}
                    <nav aria-label='breadcrumb'>
                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'><Link to='/'>{text.label_dashboard}</Link></li>
                            <li className='breadcrumb-item'><Link to='/reservations'>{text.label_reservation}</Link>
                            </li>
                            <li className='breadcrumb-item active'
                                aria-current='page'>{text.button_add}</li>
                        </ol>
                    </nav>
                    <h2 className='text-uppercase'>{text.button_add} {text.label_reservation}</h2>

                    <div className='row'>
                        <div className='col-lg-4 col-xl-4 card-white mb-3'>
                            <div className='col-12 row m-0 p-0'>
                                <form className='col-md-12 mb-2 p-0'>
                                    <div className='d-inline-flex align-items-center  p-0' >
                                        <Checkbox
                                            style={{ color: '#419AD2', padding: 0, paddingRight: 10, marginBottom: 20 }}
                                            className='mb-0'
                                            checked={!!this.state.isShuttle}
                                            onChange={e => {
                                                const { warehouse } = this.state

                                                this.setState({ isShuttle: e.target.checked },
                                                    // check value between  ✅ )
                                                    () => !!warehouse && this.__fetchReservationList(warehouse)
                                                )
                                            }} />
                                        Gunakan Jasa Pengiriman Shuttle
                                    </div>

                                    <div className='form-group text-left position-relative'>
                                        <TextField
                                            select
                                            id='warehouse'
                                            name='warehouse'
                                            label={text.label_warehouse}
                                            onChange={(e) => this.handleStep1(e, 'warehouse')}
                                            value={this.state.warehouse}
                                            disabled={this.state.loading}
                                            fullWidth
                                        >
                                            {this.state.warehouseList.map((option, idx) => (
                                                <MenuItem key={idx}
                                                    value={option.id}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.validator.message('warehouse', this.state.warehouse, 'required')}
                                        <div className='text-danger'>{this.state.errors.warehouse}</div>
                                        {this.state.loading &&
                                            <i className='fa fa-spinner fa-spin spin-absolute'>&nbsp; </i>}
                                    </div>



                                    {this.state.warehouse && (
                                        <div className='col-12 p-0'>
                                            <div className='col-md-12 p-0 m-0'>
                                                <div className='card-cream'>
                                                    <div className='row mx-auto py-4 align-items-center row'>
                                                        <div className='col-10 text-left p-10 color-brown-grey'>
                                                            <label className='mb-0'><i className='fas fa-warehouse pr-2'> </i> {text.label_warehouse_address}
                                                            </label>
                                                            <p className='p-12 color-gunmetal mb-0'>{this.state.selectedWarehouseAddress}</p>
                                                        </div>
                                                        <div className='col-2'>
                                                            <i className='fas fa-map-marker-alt color-reddish'> </i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* not shuttle */}
                                            {!this.state.isShuttle &&
                                                <div className='form-group date p-0 m-0'>
                                                    <TextField
                                                        select
                                                        id='time'
                                                        name='time'
                                                        className='text-left'
                                                        label={text.label_time}
                                                        onChange={(e) => this.handleStep1(e, 'time')}
                                                        value={this.state.time}
                                                        disabled={this.state.loading2}
                                                        fullWidth
                                                    >
                                                        {this.state.reservationList.map((option, idx) => (
                                                            <MenuItem key={idx}
                                                                value={option.reservationDate}>
                                                                {option.reservationDateString}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                    {this.validator.message('time', this.state.time, 'required')}
                                                    <div className='text-danger'>{this.state.errors.time}</div>

                                                </div>
                                            }

                                            {this.state.loading2 &&
                                                <i className='fa fa-spinner fa-spin spin-absolute'>&nbsp; </i>}

                                            {
                                                !!this.state.isShuttle && this.state.shuttleInfo &&
                                                <>
                                                    <div className='col-md-12 p-0 m-0'>
                                                        <div className='card-cream'>
                                                            <div className='row mx-auto py-4 align-items-center row'>
                                                                <div className='col-10 text-left p-10 color-brown-grey'>
                                                                    <label className='mb-0'><i className='fas fa-warehouse pr-2'> </i> {text.label_warehouse_address} (HQ)
                                                                    </label>
                                                                    <p className='p-12 color-gunmetal mb-0'>{`${this.state.shuttleInfo.HQ.address1}, ${this.state.shuttleInfo.HQ.address2}, ${this.state.shuttleInfo.HQ.city},  ${this.state.shuttleInfo.HQ.state}, ${this.state.shuttleInfo.HQ.postal_code}`}</p>
                                                                </div>
                                                                <div className='col-2'>
                                                                    <i className='fas fa-map-marker-alt color-reddish'> </i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='p-3 text-white my-2' style={{ borderRadius: 10, background: '#818cc7', fontSize: 12 }}>
                                                        <ul>
                                                            <li>Jadwal Terdekat HQ ke {this.state.warehouseList.find(x => x.id === this.state.warehouse)['name']} Tgl:&nbsp;
                                                    <strong>{moment(this.state.shuttleInfo.shuttle_sent_date).format('DD-MMMM-YYYY, HH:mm')}</strong>

                                                            </li>
                                                            <li>
                                                                Pastikan Barang Anda Sampai di HQ Tgl: &nbsp;
                                                    <strong>{moment(this.state.shuttleInfo.shuttle_received_deadline).format('DD-MMMM-YYYY, HH:mm')}</strong>
                                                            </li>
                                                            <li>
                                                                Akan Dikenakan Biaya Pengiriman Rp 30.000,-
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </>
                                            }

                                            {this.state.loadingChooseTime && !this.state.isShuttle ?
                                                <div className='col-12 p-0 m-0'>
                                                    <div className='alert background-grey color-white mt-2 p-12 m-0 mt-4 text-center'>
                                                        <i className='fa fa-spinner fa-spin'> </i>
                                                    </div>
                                                </div>
                                                : this.state.time && this.state.step2 ?
                                                    <div className='col-12 p-0 m-0'>
                                                        <div className='alert background-green color-white mt-2 p-12 m-0'>
                                                            <i className='fas fa-exclamation-circle'> </i>&nbsp;{text.reservation_step1_alert}
                                                        </div>
                                                    </div> : this.state.time && this.state.step2 == false && this.state.errStep1Time ?
                                                        <div className='col-12 p-0 m-0'>
                                                            <div className='alert background-reddish color-white mt-2 p-12 m-0'>
                                                                <i className='fas fa-exclamation-circle'> </i>&nbsp;{this.state.errStep1Time}
                                                            </div>
                                                        </div> : ''
                                            }
                                        </div>
                                    )}

                                </form>
                            </div>
                        </div>
                        {this.state.step2 ?
                            <div className='col-lg-12 col-xl-12 card-white mb-3'>
                                <div className='col-12 row m-0 p-0'>
                                    {/*<div className='col-md-12 mb-2 p-0'>*/}
                                    <p className='p-18 pt-3 mb-4'><b>{text.reservation_step2_text}</b></p>
                                    <hr className='col-12 p-0 mt-0' />
                                    {/* pin2 */}
                                    <div className='col-12'>
                                        <form name='add'
                                            id='addProduct'
                                            className='row'
                                            noValidate>

                                            {this.state.productList_tmp.length > 0 ?
                                                <div className='col-md-6 col-lg-5 mb-2'>
                                                    <div className='form-group'>
                                                        <TextField
                                                            select
                                                            id='product'
                                                            name='product'
                                                            label='Cari SKU / Nama Produk'
                                                            onChange={(e) => this.handleAdd(e, 'product')}
                                                            value={this.state.product}
                                                            disabled={this.state.loadingProduct}
                                                            fullWidth
                                                        >
                                                            {this.state.productList_tmp.map((option, idx) => (
                                                                <MenuItem key={idx}
                                                                    value={option}>
                                                                    {option.skuNumber} - {option.name}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                        <div className='text-danger'>{this.state.errors.product}</div>
                                                    </div>  </div> : <div></div>}
                                            {/*<div className='col-md-6 col-lg-5 mb-2'>*/}
                                            {/*<div className='form-group'>*/}
                                            {/*    <label>Cari SKU / Nama Produk</label>*/}
                                            {/*    <p>{text.label_stock_unavailable}</p>*/}
                                            {/*</div></div>*/}

                                            {/* pin3 */}
                                            <div className='col-6'>
                                                <button type="button" className="btn-add mt-2" onClick={this.handleOpen}>{text.label_add_product}</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div className='clearfix'> </div>
                                    <div className='table-wrapper col-12 row'>
                                        <Table className='table-list'
                                            size='small'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className='clickable'>
                                                        <p className='mb-0 p-10'>{text.label_sku}<span className='d-none d-md-inline p-10'> SKU</span>
                                                        </p></TableCell>
                                                    <TableCell className='clickable'>
                                                        <p className='mb-0 p-10'>{text.label_product}</p></TableCell>
                                                    <TableCell className='clickable'>
                                                        <p className='mb-0 p-10'>{text.label_quantity}</p></TableCell>
                                                    <TableCell className='clickable'>
                                                        <p className='mb-0 p-10'>{text.label_product_price}</p>
                                                    </TableCell>
                                                    <TableCell className='clickable'>
                                                        <p className='mb-0 p-10'>{text.label_locker}</p></TableCell>
                                                    <TableCell className='clickable'>
                                                        <p className='mb-0 p-10'>{text.label_warehouses}</p></TableCell>
                                                    <TableCell className='clickable'>
                                                        <p className='mb-0 p-10'>{text.label_available}</p></TableCell>
                                                    <TableCell className='clickable'>
                                                        <p className='mb-0 p-10'>{text.label_delete}</p></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.loadingProduct ? (
                                                    <TableRow>
                                                        <TableCell colSpan={8}
                                                            align='center'
                                                            className='py-5'>
                                                            <CircularProgress color='primary' />
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                        this.state.productList.length === 0 ? (
                                                            <TableRow style={{ height: 50 }}>
                                                                <TableCell colSpan={8}
                                                                    style={{ textAlign: 'center' }}>{text.label_no}</TableCell>
                                                            </TableRow>
                                                        ) : (
                                                                this.state.productList.map((row, idx) => (
                                                                    <TableRow
                                                                        key={row.id}
                                                                        selected={row.selected}>
                                                                        <TableCell>{row.sku ? row.sku : '-'}</TableCell>
                                                                        <TableCell>{row.name ? row.name : '-'}</TableCell>
                                                                        <TableCell>
                                                                            <TextField
                                                                                type='number'
                                                                                id={'quantity-' + idx}
                                                                                name={'quantity-' + idx}
                                                                                onChange={(e) => this.handleChangeAdd(e, 'quantity', idx)}
                                                                                label=""
                                                                                value={row.quantity}
                                                                                fullWidth
                                                                            />
                                                                            {this.validator.message('quantity-' + idx, row.quantity, 'numeric|required')}
                                                                            <div className='text-danger'>{this.state.errors['quantity-' + idx]}</div>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {row.price ?
                                                                                (
                                                                                    <NumberFormat thousandSeparator={'.'} decimalSeparator={','}
                                                                                        fixedDecimalScale={false} decimalScale={0}
                                                                                        value={row.display_price} displayType={'text'}
                                                                                        renderText={value => value} />
                                                                                )
                                                                                :
                                                                                (<>-</>)
                                                                            }

                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {!this.state.loading3 &&
                                                                                <span className='info'>{row.lockerSizeName ? row.lockerSizeName :
                                                                                    <i className="fas fa-times-circle color-reddish p-12"> </i>}</span>}
                                                                            {this.state.loading3 &&
                                                                                <i className='fa fa-spinner fa-spin'>&nbsp; </i>}
                                                                        </TableCell>
                                                                        <TableCell>{row.storage ? row.storage_id : '-'}</TableCell>
                                                                        <TableCell>
                                                                            {
                                                                                this.state.loadingReservation ?
                                                                                    <i className='fa fa-spinner fa-spin p-12'> </i>
                                                                                    :
                                                                                    row.slot ?
                                                                                        <i className='fas fa-check-circle color-leaf p-12'> </i> :
                                                                                        <i className="fas fa-times-circle color-reddish p-12"> </i>
                                                                            }
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <button className='button-transparent'
                                                                                onClick={(e) => this.handleMinus(row.id)}>
                                                                                <i className='fas fa-backspace color-reddish p-12'> </i>
                                                                            </button>
                                                                        </TableCell>
                                                                        <TableCell></TableCell>
                                                                    </TableRow>
                                                                ))
                                                            )
                                                    )}

                                            </TableBody>
                                        </Table>
                                    </div>

                                    <div className='row col-12 justify-content-end mt-2 m-0'>
                                        <div className='col-md-6 text-right'>
                                            {/*<Button
                                            variant='contained'
                                            className='btn-link mr-3'
                                            onClick={() => this.handleGo('/')}
                                        >{text.button_skip}</Button>*/}

                                            <Button
                                                variant='contained'
                                                color='primary'
                                                className=''
                                                onClick={this.handleOpenSummary}
                                                disabled={!this.state.passed}
                                            >
                                                {text.button_next}
                                            </Button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            :
                            this.state.step2 &&
                            <div className='alert-heading background-green p-12 color-white mt-4'>
                                <i className='fas fa-exclamation-circle'> </i>&nbsp;{text.reservation_step1_alert}
                            </div>
                        }
                    </div>

                    {/*<ToastContainer />*/}
                    <ToastContainer autoClose={false} />
                    <Dialog
                        maxWidth='sm'
                        fullWidth={true}
                        open={this.state.showDialog}
                        onClose={this.handleClose}
                        aria-labelledby='form-dialog-title'>
                        <DialogTitle id='form-dialog-title'>{text.label_add_product}</DialogTitle>
                        <DialogContent>
                            <form name='add' id='addProduct' className='row' noValidate>
                                <div className='col-12 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='skuNumber'
                                            name='skuNumber'
                                            label={text.label_sku}
                                            onChange={(e) => this.handleChange(e, 'skuNumber')}
                                            value={this.state.skuNumber}
                                            fullWidth
                                        />
                                        {this.validatorAdd.message('skuNumber', this.state.skuNumber, 'required')}
                                        <div className='text-danger'>{this.state.errors.skuNumber}</div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='form-group position-relative'>
                                        <Tooltip
                                            arrow
                                            title={text.label_tooltip}
                                            placement='top'>
                                            <i className='fas fa-question-circle tooltip-icon'> </i>
                                        </Tooltip>
                                        <TextField
                                            type='text'
                                            id='imageFiles'
                                            name='imageFiles'
                                            label={text.label_upload}
                                            value={this.state.image_name}
                                            fullWidth
                                            autoComplete='off'
                                        />
                                        <label
                                            htmlFor="image"
                                            id="upload-image"
                                        >{text.label_browse}</label>
                                        <TextField
                                            accept='.jpg,.jpeg,.png'
                                            type='file'
                                            id='image'
                                            name='image'
                                            className='avatar d-none'
                                            onChange={this.handleUpload}
                                            fullWidth
                                        />
                                        {this.validatorAdd.message('image', this.state.image, 'required')}
                                        <div className='text-danger'>{this.state.errors.image}</div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='name'
                                            name='name'
                                            label={text.label_product}
                                            onChange={(e) => this.handleChange(e, 'name')}
                                            value={this.state.name}
                                            fullWidth
                                        />
                                        {this.validatorAdd.message('name', this.state.name, 'required')}
                                        <div className='text-danger'>{this.state.errors.name}</div>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            select
                                            id='storage'
                                            name='storage'
                                            label={text.label_storage}
                                            onChange={(e) => this.handleChange(e, 'storage')}
                                            value={this.state.storage}
                                            fullWidth
                                        >
                                            {/*  <MenuItem value='Frozen -20C'>
                                            Frozen -20C
                                        </MenuItem>*/}
                                            {this.state.storageList.map((option, idx) => (
                                                <MenuItem key={idx} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {this.validatorAdd.message('storage', this.state.storage, 'required')}
                                        <div className='text-danger'>{this.state.errors.storage}</div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='row align-items-center'>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <TextField
                                                    select
                                                    id='category'
                                                    name='category'
                                                    label={text.label_category}
                                                    onChange={(e) => this.handleChange(e, 'category')}
                                                    value={this.state.category}
                                                    fullWidth
                                                >
                                                    <MenuItem value='Beras'>
                                                        Beras
                                                    </MenuItem>
                                                    <MenuItem value='Bumbu Dan Sambal'>
                                                        Bumbu Dan Sambal
                                                    </MenuItem>
                                                    <MenuItem value='Daging Ayam'>
                                                        Daging Ayam
                                                    </MenuItem>
                                                    <MenuItem value='Daging Sapi'>
                                                        Daging Sapi
                                                    </MenuItem>
                                                    <MenuItem value='Es Krim'>
                                                        Es Krim
                                                    </MenuItem>
                                                    <MenuItem value='Ikan Dan Hasil Laut'>
                                                        Ikan Dan Hasil Laut
                                                    </MenuItem>
                                                    <MenuItem value='Makanan Siap Masak'>
                                                        Makanan Siap Masak
                                                    </MenuItem>
                                                    <MenuItem value='Makanan Siap Saji'>
                                                        Makanan Siap Saji
                                                    </MenuItem>
                                                    <MenuItem value='Minuman'>
                                                        Minuman
                                                    </MenuItem>
                                                    <MenuItem value='Oleh-Oleh'>
                                                        Oleh-Oleh
                                                    </MenuItem>
                                                    <MenuItem value='Roti Dan Kue'>
                                                        Roti Dan Kue
                                                    </MenuItem>
                                                    <MenuItem value='Selai Dan Mentega'>
                                                        Selai Dan Mentega
                                                    </MenuItem>
                                                    <MenuItem value='Lainnya'>
                                                        Lainnya
                                                    </MenuItem>
                                                </TextField>
                                                {this.validatorAdd.message('category', this.state.category, 'required')}
                                                <div className='text-danger'>{this.state.errors.category}</div>
                                            </div>
                                        </div>

                                        {this.state.category === 'Lainnya' &&
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <TextField
                                                        type='text'
                                                        id='name'
                                                        name='name'
                                                        label={text.label_category}
                                                        onChange={(e) => this.handleChange(e, 'category_other')}
                                                        value={this.state.category_other}
                                                        fullWidth
                                                    />
                                                    <div className='text-danger'>{this.state.errors.category_other}</div>
                                                </div>
                                            </div>
                                        }

                                        <div className='col-md-4'>
                                            <div className='form-group'>
                                                <TextField
                                                    type='number'
                                                    id='weight'
                                                    name='weight'
                                                    label={text.label_weight}
                                                    onChange={(e) => this.handleChange(e, 'weight')}
                                                    value={this.state.weight}
                                                    fullWidth
                                                />
                                                {this.validatorAdd.message('weight', this.state.weight, 'required')}
                                                <div className='text-danger'>{this.state.errors.weight}</div>
                                            </div>
                                        </div>
                                        <div className='col-md-2 pl-0'>
                                            <span className='info'>Grams</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 mt-3 mb-2'>
                                    <div className='alert-warning'>
                                        <p className='mb-0'>{text.product_alert}!</p>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='row align-items-center'>
                                        <div className='col-md-3'>
                                            <div className='form-group position-relative'>
                                                <i className='fas fa-question-circle tooltip-icon'> </i>
                                                <div className='tooltip-image'>
                                                    <div className='d-flex justify-content-between mb-2'>
                                                        <span>Horisontal</span>
                                                        <span>Vertikal</span>
                                                    </div>
                                                    <img src={Length} alt='length' className='img-fluid' />
                                                </div>
                                                <TextField
                                                    type='number'
                                                    id='length'
                                                    name='length'
                                                    label={text.label_length}
                                                    onChange={(e) => this.handleChange(e, 'length')}
                                                    value={this.state.length}
                                                    fullWidth
                                                />
                                                {this.validatorAdd.message('length', this.state.length, 'required|numeric')}
                                                <div className='text-danger'>{this.state.errors.length}</div>
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className='form-group position-relative'>
                                                <i className='fas fa-question-circle tooltip-icon'> </i>
                                                <div className='tooltip-image'>
                                                    <div className='d-flex justify-content-between mb-2'>
                                                        <span>Horisontal</span>
                                                        <span>Vertikal</span>
                                                    </div>
                                                    <img src={Width} alt='width' className='img-fluid' />
                                                </div>
                                                <TextField
                                                    type='number'
                                                    id='width'
                                                    name='width'
                                                    label={text.label_width}
                                                    onChange={(e) => this.handleChange(e, 'width')}
                                                    value={this.state.width}
                                                    fullWidth
                                                />
                                                {this.validatorAdd.message('width', this.state.width, 'required|numeric')}
                                                <div className='text-danger'>{this.state.errors.width}</div>
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className='form-group position-relative'>
                                                <i className='fas fa-question-circle tooltip-icon'> </i>
                                                <div className='tooltip-image'>
                                                    <div className='d-flex justify-content-between mb-2'>
                                                        <span>Horisontal</span>
                                                        <span>Vertikal</span>
                                                    </div>
                                                    <img src={Height} alt='height' className='img-fluid' />
                                                </div>
                                                <TextField
                                                    type='number'
                                                    id='height'
                                                    name='height'
                                                    label={text.label_height}
                                                    onChange={(e) => this.handleChange(e, 'height')}
                                                    value={this.state.height}
                                                    fullWidth
                                                />
                                                {this.validatorAdd.message('height', this.state.height, 'required|numeric')}
                                                <div className='text-danger'>{this.state.errors.height}</div>
                                            </div>
                                        </div>

                                        <div className='col-md-3'>
                                            <label>{text.label_locker}</label>
                                            <span>
                                                {!this.state.loading3 && <span className='info'>{this.state.lockerSizeName !== 0 ? this.state.lockerSizeName : text.label_no_locker}</span>}
                                                {this.state.loading3 && <i className='fa fa-spinner fa-spin'>&nbsp; </i>}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='row align-items-center'>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <TextField
                                                    select
                                                    id='supliedPackaging'
                                                    name='supliedPackaging'
                                                    label={text.label_packaging}
                                                    onChange={(e) => this.handleChange(e, 'supliedPackaging')}
                                                    value={this.state.supliedPackaging}
                                                    fullWidth
                                                >
                                                    <MenuItem value='Vacuum Bag'>
                                                        Vacuum Bag
                                                    </MenuItem>
                                                    <MenuItem value='Plastic Bag'>
                                                        Plastic Bag
                                                    </MenuItem>
                                                    <MenuItem value='Other'>
                                                        Other
                                                    </MenuItem>
                                                </TextField>
                                                {this.validatorAdd.message('supliedPackaging', this.state.supliedPackaging, 'required')}
                                                <div className='text-danger'>{this.state.errors.supliedPackaging}</div>
                                            </div>
                                        </div>

                                        {this.state.supliedPackaging === 'Other' &&
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <TextField
                                                        type='text'
                                                        id='otherpackaging'
                                                        name='otherpackaging'
                                                        label={text.label_other}
                                                        onChange={(e) => this.handleChange(e, 'otherpackaging')}
                                                        value={this.state.otherpackaging}
                                                        fullWidth
                                                    />
                                                    {this.validatorAdd.message('otherpackaging', this.state.otherpackaging, 'required')}
                                                    <div className='text-danger'>{this.state.errors.otherpackaging}</div>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='row align-items-center'>
                                        <div className='col-md-4 mb-2'>
                                            <div className='form-group'>
                                                <TextField
                                                    type='number'
                                                    id='shelfLife'
                                                    name='shelfLife'
                                                    label={text.label_shelf}
                                                    onChange={(e) => this.handleChange(e, 'shelfLife')}
                                                    value={this.state.shelfLife}
                                                    fullWidth
                                                />
                                                {this.validatorAdd.message('shelfLife', this.state.shelfLife, 'required')}
                                                <div className='text-danger'>{this.state.errors.shelfLife}</div>
                                            </div>
                                        </div>
                                        <div className='col-md-2 pl-0'>
                                            <span className='info'>{text.label_days}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-12 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='price'
                                            name='price'
                                            label={text.label_product_price}
                                            onChange={(e) => this.handleChange(e, 'price')}
                                            value={this.state.price}
                                            InputProps={{
                                                inputComponent: this.NumberFormatCustom,
                                            }}
                                            fullWidth
                                        />
                                        {this.validatorAdd.message('price', this.state.price, 'required')}
                                        <div className='text-danger'>{this.state.errors.price}</div>
                                    </div>
                                </div>
                                <div className='col-12 mb-2'>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='description'
                                            name='description'
                                            label={text.label_product_desc}
                                            onChange={(e) => this.handleChange(e, 'description')}
                                            value={this.state.description}
                                            fullWidth
                                            multiline
                                            rows={4}
                                        />
                                        {this.validatorAdd.message('description', this.state.description, 'required')}
                                        <div className='text-danger'>{this.state.errors.description}</div>
                                    </div>
                                </div>
                            </form>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant='contained'
                                className='btn-link mr-3'
                                onClick={this.handleClose}
                                disabled={this.state.loadingButton || this.state.loading3}
                            >
                                {text.button_back}
                            </Button>
                            <Button
                                variant='contained'
                                color='primary'
                                className=''
                                onClick={this.handleAddProduct}
                                disabled={this.state.loadingButton || this.state.loading3}
                            >
                                {text.button_add}{this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i>}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        disableBackdropClick
                        disableEscapeKeyDown
                        maxWidth='md'
                        fullWidth={true}
                        open={this.state.showDialogSummary}
                        onClose={this.handleClose}
                        aria-labelledby='form-dialog-title'>
                        <DialogTitle id='form-dialog-title'>{text.label_reservation_summary}</DialogTitle>
                        <DialogContent>
                            <table className="table table-borderless">
                                <thead style={{ borderBottom: `2px solid #d8d8d8`, fontSize: 12 }}>
                                    <tr>
                                        <th scope="col">SKU Produk SKU</th>
                                        <th scope="col">Nama Produk</th>
                                        <th scope="col">Jumlah</th>
                                        <th scope="col">Harga Produk</th>
                                        <th scope="col">Ukuran Loker</th>
                                        <th scope="col">Tempat Penyimpanan</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: 14 }}>
                                    {this.state.productList.map((item, i) => (
                                        <tr key={i}>
                                            <td >{item.sku}</td>
                                            <td >{item.name}</td>
                                            <td>{item.quantity}</td>
                                            <td>
                                                <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false} decimalScale={0}
                                                    value={item.display_price} displayType={'text'} renderText={value => value} />
                                            </td>
                                            <td>{item.lockerSizeName}</td>
                                            <td>{item.storage_id}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant='contained'
                                className='btn-link mr-3'
                                onClick={this.handleClose}
                                disabled={this.state.loadingButton || this.state.loading3}
                            >
                                {text.button_back}
                            </Button>
                            <Button
                                variant='contained'
                                color='primary'
                                className=''
                                onClick={this.handleReservation}
                                disabled={!this.state.passed}
                            >
                                {text.button_next}
                                {!this.state.passed && this.state.step2 &&
                                    <i className='fa fa-spinner fa-spin'> </i>
                                }
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>

            )
        }

    }
}

class PrintLabels extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            email: '',
            labels: this.props.data,
        };
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Berhasil';

    }

    render() {

        return (
            <table width="100%">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        this.state.labels.length > 0 &&
                        this.state.labels.map((row, idx) => {
                            return (
                                <tr key={idx}>
                                    {
                                        row.map(item => {
                                            return (
                                                <td key={item.ikuId} width="33%">
                                                    <div className='card card-label'>
                                                        <QRCode
                                                            size={75}
                                                            value={item.ikuId} />
                                                        <div className='label-content'>
                                                            <h4 className='mb-1'>IKU: {item.ikuId}</h4>
                                                            <p><strong>{item.skuNumber} - {item.productName}</strong></p>
                                                            <p>Locker: {item.locker}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                            );
                                        })
                                    }
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
        )
    }
}

class PrintLabelsNote extends Component {
    constructor(props) {

        super(props);

        this.state = {
            loadingNote: false,
            email: '',
            data: this.props.data,
            labels: this.props.labels,
            lang: this.props.lang,
            products: this.props.data.products ? this.props.data.products : [],
            productsNote: this.props.data.generateData ? this.props.data.generateData : [],
        };
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Berhasil';
    }

    render() {

        let lang = {};
        if (this.state.lang === 'indo') {
            lang = language.id;
        } else {
            lang = language.en;
        }
        const text = lang;

        return (
            <table width="100%" cellPadding='3'>
                <thead>
                    <tr>
                        <th colSpan={3} className="text-center">
                            <img src={Logo} alt='logo' className='img-logo' />
                            <p className="text-big">{text.label_nota_delivery}</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table width="700px" style={{ margin: 'auto' }}>
                                <thead>
                                    <tr>
                                        <th className="text-left">
                                            <label className='p-10 label-note text-left'>{text.label_nota}</label>
                                            <p className='p-12 mb-0'><strong>{this.state.data.nota}</strong></p>
                                        </th>
                                        <th style={{ textAlign: 'right' }} >
                                            {this.state.data.nota &&
                                                <QRCode
                                                    size={100}
                                                    value={this.state.data.nota} />
                                            }
                                            <small className='p-8 text-grey d-block'>{this.state.data.nota}</small>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="text-left">
                                        <td width="50%">
                                            <label className='p-10 label-note text-left'>{text.label_company_only}</label>
                                            <p className='p-12 mb-0'><strong>{this.state.data.company_name}</strong></p>
                                            <p className='p-12 text-grey'>{this.state.data.primary_address}, {this.state.data.primary_city}, {this.state.data.primary_state}</p>
                                        </td>
                                        <td width="50%"></td>
                                    </tr>
                                    <tr className="text-left">
                                        <td width="50%">
                                            <label className='p-10 label-note'>{text.label_warehouses}</label>
                                            <p className='p-12'><strong>{this.state.data.warehouse}</strong></p>
                                        </td>
                                        <td width="50%">
                                            <label className='p-10 label-note'>{text.label_name_contact}</label>
                                            <p className='mb-0 p-12'><strong>{this.state.data.contact_name}</strong></p>
                                            <p className='p-12 text-grey'>{this.state.data.contact_email}/{this.state.data.contact_phone_office}/{this.state.data.contact_phone_cell}</p>
                                        </td>
                                    </tr>
                                    <tr className="text-left">
                                        <td colSpan={2} width='100%'>
                                            <div className='card-cream mt-0'>
                                                <div className='row mx-auto py-4 align-items-center'>
                                                    <div className='col-11 text-left p-10 color-brown-grey'>
                                                        <label className='mb-0'><i className='fas fa-warehouse pr-2'> </i> {text.label_warehouse_address}</label>
                                                        <p className='p-12 color-gunmetal mb-0'>{this.state.data.warehouse_address1 + ' ' + this.state.data.warehouse_address2 + ', ' + this.state.data.warehouse_city + ', ' + this.state.data.warehouse_state}</p>
                                                    </div>
                                                    <div className='col-1'>
                                                        <i className='fas fa-map-marker-alt color-reddish'> </i>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="text-left">
                                        <td width="50%">
                                            <h3 className='p-18'><strong>{text.label_time}</strong></h3>
                                            <p className='p-12'>{this.state.data.reservation_date}</p>
                                        </td>
                                        <td width="50%"></td>
                                    </tr>
                                    <tr className="text-left">
                                        <td colSpan={2} width='100%'>
                                            <div className='card-nota d-block'>
                                                <table width='100%'>
                                                    <tbody>
                                                        <tr >
                                                            <th>
                                                                <h3 className='p-18'><strong>{text.reservation_product}</strong></h3>
                                                            </th>
                                                            <th></th>
                                                            <th></th>
                                                        </tr>
                                                        <tr>
                                                            <td><p className='p-10 mb-0'>{text.label_product}</p></td>
                                                            <td><p className='p-10 mb-0 text-center'>{text.label_quantity}</p></td>
                                                            <td><p className='p-10 mb-0 text-right'>{text.label_sku}</p></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={3} width="100%"><hr /></td>
                                                        </tr>
                                                        {
                                                            this.state.products.length > 0 &&
                                                            this.state.products.map(function (item) {
                                                                return (<tr key={item.sku_number}>
                                                                    <td width="33%">
                                                                        <p className='p-12'>{item.name}</p>
                                                                    </td>
                                                                    <td width="33%">
                                                                        <p className='p-12 text-center'>{item.quantity}</p>
                                                                    </td>
                                                                    <td width="33%">
                                                                        <p className='p-12 text-right'>{item.sku_number}</p>
                                                                    </td>
                                                                </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2} width='100%'>
                                            <div className='card-cream p-3'>
                                                <p className='p-10 color-gunmetal mb-0'>*{text.note_text}</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table width="700px" style={{ margin: 'auto' }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2} className="text-left" style={{ 'paddingBottom': '15px' }}>
                                            <h3 className='p-18'><strong>{text.label_iku}</strong></h3>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr >
                                        <td colSpan={2}>
                                            <table width='100%'>
                                                <thead><tr><td colSpan={2}>&nbsp;</td></tr></thead>
                                                <tbody>
                                                    {
                                                        this.state.productsNote ?
                                                            this.state.productsNote.map((row, index) => {
                                                                return (
                                                                    <tr key={index + "_tab"}>
                                                                        {
                                                                            row.map((n, ni) => {
                                                                                if (ni == 1 && row.length < 3) {
                                                                                    return (
                                                                                        <td
                                                                                            colSpan={1}
                                                                                            key={(n.ikuId ? n.ikuId : 'manual') + '_' + ni}
                                                                                            width="49%"
                                                                                            style={{
                                                                                                'borderTop': '2px dashed silver',
                                                                                                'borderBottom': '2px dashed silver',
                                                                                            }}>

                                                                                            <div style={{
                                                                                                transform: 'rotate(90deg)',
                                                                                                position: 'relative',
                                                                                                height: '12px',
                                                                                                width: '12px',
                                                                                                top: '0px',
                                                                                                left: '0px'
                                                                                            }}>
                                                                                                <div style={{
                                                                                                    position: 'absolute',
                                                                                                    transform: 'rotate(360deg)',
                                                                                                    left: '0px',
                                                                                                    right: '0px',
                                                                                                    top: '0px',
                                                                                                    bottom: '0px',
                                                                                                    width: '100px'
                                                                                                }}>potong disini</div>
                                                                                            </div>
                                                                                            <span style={{ position: 'relative', top: '-78px' }}>potong disini</span>

                                                                                            <div className="col-12 mb-4">
                                                                                            </div>
                                                                                        </td>
                                                                                    );
                                                                                }
                                                                                if (ni == 0) {
                                                                                    return (
                                                                                        <td
                                                                                            colSpan={1}
                                                                                            key={(n.ikuId ? n.ikuId : 'manual') + '_' + ni}
                                                                                            width="49%"
                                                                                            style={{
                                                                                                'borderTop': '2px dashed silver',
                                                                                                'borderBottom': '2px dashed silver',
                                                                                                'borderRight': '2px dashed silver'
                                                                                            }}>
                                                                                            <span style={{ position: 'relative', top: '-20px' }}>potong disini</span>
                                                                                            <div className="col-12 mb-4">
                                                                                                <p className="text-left mb-1">
                                                                                                    <strong>IKU-{n.ikuId}</strong></p>
                                                                                                <p className="text-left mb-1">{n.productName} - {n.weight}</p>

                                                                                                <div className='card card-label'>
                                                                                                    <div className='col-12 row p-0 m-0'>
                                                                                                        <div className='' style={{ width: '40%' }}>
                                                                                                            <p>{text.label_locker}</p>
                                                                                                            <p><strong>{n.lockerSize}</strong></p>
                                                                                                        </div>
                                                                                                        <div className='' style={{ width: '60%' }}>
                                                                                                            <p>{text.label_warehouses}</p>
                                                                                                            <p><strong>{n.warehouse}/{n.slot}</strong></p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                    );
                                                                                }
                                                                                if (ni == 2) {
                                                                                    return (
                                                                                        <td
                                                                                            colSpan={1}
                                                                                            key={(n.ikuId ? n.ikuId : 'manual') + '_' + ni}
                                                                                            width="49%"
                                                                                            style={{
                                                                                                'borderTop': '2px dashed silver',
                                                                                                'borderBottom': '2px dashed silver',
                                                                                            }}>

                                                                                            <div style={{
                                                                                                transform: 'rotate(90deg)',
                                                                                                position: 'relative',
                                                                                                height: '12px',
                                                                                                width: '12px',
                                                                                                top: '45px',
                                                                                                left: '0px'
                                                                                            }}>
                                                                                                <div style={{
                                                                                                    position: 'absolute',
                                                                                                    transform: 'rotate(360deg)',
                                                                                                    left: '0px',
                                                                                                    right: '0px',
                                                                                                    top: '0px',
                                                                                                    bottom: '0px',
                                                                                                    width: '100px'
                                                                                                }}>potong disini</div>
                                                                                            </div>
                                                                                            <span style={{ position: 'relative', top: '-26px' }}>potong disini</span>

                                                                                            <div className="col-12 mb-4">
                                                                                                <p className="text-left mb-1">
                                                                                                    <strong>IKU-{n.ikuId}</strong></p>
                                                                                                <p className="text-left mb-1">{n.productName} - {n.weight}</p>

                                                                                                <div className='card card-label'>
                                                                                                    <div className='col-12 row p-0 m-0'>
                                                                                                        <div className='' style={{ width: '40%' }}>
                                                                                                            <p>{text.label_locker}</p>
                                                                                                            <p><strong>{n.lockerSize}</strong></p>
                                                                                                        </div>
                                                                                                        <div className='' style={{ width: '60%' }}>
                                                                                                            <p>{text.label_warehouses}</p>
                                                                                                            <p><strong>{n.warehouse}/{n.slot}</strong></p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                    );
                                                                                }
                                                                            })
                                                                        }
                                                                    </tr>
                                                                );
                                                            })
                                                            : <tr><td colSpan={2}>Data Kosong</td></tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReservationsAdd));